module.exports = __webpack_public_path__ + "static/media/carrorama-video-numeros.4f81b122.jp2";